<div class="modal fade" id="unifiedViaticosModal" tabindex="-1" aria-labelledby="unifiedViaticosModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-xl modal-dialog-centered">
    <div class="modal-content">

      <div class="modal-header border-0 pb-0 position-relative">
        <button type="button" class="btn-close position-absolute top-0 end-0 m-3" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <div class="modal-body text-center pt-0 px-4">
        <h5 class="fw-bold mb-1">Viáticos unificados</h5>
        <p class="text-muted small mb-4">Los siguientes servicios se encuentran unificados a estos viáticos</p>

        <ag-grid-angular
          class="ag-theme-alpine unified-grid"
          [rowData]="rowData"
          [columnDefs]="columnDefs"
          [defaultColDef]="defaultColDef"
          [domLayout]="'autoHeight'"
          (cellClicked)="onCellClicked($event)"
          (gridReady)="onGridReady($event)">
        </ag-grid-angular>
      </div>

      <div class="modal-footer border-0 justify-content-center gap-3 pt-2 pb-4">
        <button type="button" class="btn btn-outline-primary d-flex align-items-center gap-2 px-4"
                (click)="separate()" [disabled]="isSeparating">
          <span *ngIf="isSeparating" class="spinner-border spinner-border-sm"></span>
          <svg *ngIf="!isSeparating" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-link-45deg" viewBox="0 0 16 16">
            <path d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1 1 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4 4 0 0 1-.128-1.287z"/>
            <path d="M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243z"/>
          </svg>
          Separar viáticos
        </button>
        <button type="button" class="btn btn-primary px-5" (click)="close()">Cerrar</button>
      </div>

    </div>
  </div>
</div>
